export default __webpack_public_path__ + "static/media/cg125.ea198d76.png";